import { render, staticRenderFns } from "./SalesReservationA.vue?vue&type=template&id=2d6e4224&scoped=true&"
import script from "./SalesReservationA.vue?vue&type=script&lang=js&"
export * from "./SalesReservationA.vue?vue&type=script&lang=js&"
import style0 from "./SalesReservationA.vue?vue&type=style&index=0&id=2d6e4224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6e4224",
  null
  
)

export default component.exports